var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useMemo, useState } from "react";
import { Dialog } from "@headlessui/react";
import { useAuth0 } from "@auth0/auth0-react";
import { apiFetch, Dropdown, StyledButton, StyledButtonStyle, TextInput, useData, } from "ee-react-components";
import { AlertSeverity, } from "ee-nestjs-interfaces";
import { orchestratorUrl } from "./api";
var SEVERITY_ITEMS = [
    { name: "Critical", value: AlertSeverity.CRITICAL },
    { name: "High", value: AlertSeverity.HIGH },
    { name: "Moderate", value: AlertSeverity.MODERATE },
    { name: "Low", value: AlertSeverity.LOW },
    { name: "Info", value: AlertSeverity.INFO },
];
export var StrategyFormDialog = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var open = _a.open, existing = _a.existing, onClose = _a.onClose, onSaved = _a.onSaved;
    var getAccessTokenSilently = useAuth0().getAccessTokenSilently;
    var signals = useData("".concat(orchestratorUrl(), "/signals")).data;
    var responses = useData("".concat(orchestratorUrl(), "/responses")).data;
    var _h = useState((_b = existing === null || existing === void 0 ? void 0 : existing.name) !== null && _b !== void 0 ? _b : ""), name = _h[0], setName = _h[1];
    var _j = useState((_c = existing === null || existing === void 0 ? void 0 : existing.description) !== null && _c !== void 0 ? _c : ""), description = _j[0], setDescription = _j[1];
    var _k = useState((_d = existing === null || existing === void 0 ? void 0 : existing.signalId) !== null && _d !== void 0 ? _d : null), signalId = _k[0], setSignalId = _k[1];
    var _l = useState((_e = existing === null || existing === void 0 ? void 0 : existing.responseId) !== null && _e !== void 0 ? _e : null), responseId = _l[0], setResponseId = _l[1];
    var _m = useState((existing === null || existing === void 0 ? void 0 : existing.threshold) != null ? String(existing.threshold) : "0.5"), threshold = _m[0], setThreshold = _m[1];
    var _o = useState((existing === null || existing === void 0 ? void 0 : existing.priority) != null ? String(existing.priority) : "10"), priority = _o[0], setPriority = _o[1];
    var _p = useState((_f = existing === null || existing === void 0 ? void 0 : existing.enabled) !== null && _f !== void 0 ? _f : true), enabled = _p[0], setEnabled = _p[1];
    var _q = useState((_g = existing === null || existing === void 0 ? void 0 : existing.alertSeverity) !== null && _g !== void 0 ? _g : AlertSeverity.MODERATE), alertSeverity = _q[0], setAlertSeverity = _q[1];
    var _r = useState(false), saving = _r[0], setSaving = _r[1];
    var _s = useState(null), error = _s[0], setError = _s[1];
    var signalItems = useMemo(function () { return (signals !== null && signals !== void 0 ? signals : []).map(function (s) { return ({ name: s.name, value: s.id }); }); }, [signals]);
    var responseItems = useMemo(function () { return (responses !== null && responses !== void 0 ? responses : []).map(function (r) { return ({ name: r.name, value: r.id }); }); }, [responses]);
    var save = function () { return __awaiter(void 0, void 0, void 0, function () {
        var t, p, body, getToken, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setError(null);
                    if (!name.trim())
                        return [2 /*return*/, setError("Name is required.")];
                    if (!signalId)
                        return [2 /*return*/, setError("Signal is required.")];
                    if (responseId == null)
                        return [2 /*return*/, setError("Response is required.")];
                    t = Number(threshold);
                    if (Number.isNaN(t) || t < 0 || t > 1)
                        return [2 /*return*/, setError("Threshold must be in [0, 1].")];
                    p = Number(priority);
                    if (Number.isNaN(p) || !Number.isInteger(p))
                        return [2 /*return*/, setError("Priority must be an integer.")];
                    body = {
                        name: name,
                        description: description,
                        signalId: signalId,
                        responseId: responseId,
                        threshold: t,
                        priority: p,
                        enabled: enabled,
                        alertSeverity: alertSeverity,
                    };
                    setSaving(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, 7, 8]);
                    getToken = function () {
                        return getAccessTokenSilently({
                            authorizationParams: { audience: process.env.AUTH0_AUDIENCE },
                        });
                    };
                    if (!existing) return [3 /*break*/, 3];
                    return [4 /*yield*/, apiFetch("".concat(orchestratorUrl(), "/strategies/").concat(existing.id), {
                            method: "PATCH",
                            body: body,
                            callbacks: { getToken: getToken },
                        })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, apiFetch("".concat(orchestratorUrl(), "/strategies"), {
                        method: "POST",
                        body: body,
                        callbacks: { getToken: getToken },
                    })];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    onSaved();
                    onClose();
                    return [3 /*break*/, 8];
                case 6:
                    e_1 = _a.sent();
                    setError(e_1.message);
                    return [3 /*break*/, 8];
                case 7:
                    setSaving(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(Dialog, { open: open, onClose: onClose, className: "relative z-50" },
        React.createElement("div", { className: "fixed inset-0 bg-black/90", "aria-hidden": "true" }),
        React.createElement("div", { className: "fixed inset-0 flex items-center justify-center p-4" },
            React.createElement(Dialog.Panel, { className: "bg-black-1100 border border-black-700 shadow-2xl rounded-[16px] p-[32px] w-full max-w-[640px] max-h-[90vh] overflow-y-auto flex flex-col gap-y-[16px]" },
                React.createElement(Dialog.Title, { className: "text-white font-N6" }, existing ? "Edit Strategy" : "New Strategy"),
                React.createElement(Field, { label: "Name" },
                    React.createElement(TextInput, { value: name, onChange: function (e) { return setName(e.target.value); } })),
                React.createElement(Field, { label: "Description" },
                    React.createElement(TextInput, { value: description, onChange: function (e) { return setDescription(e.target.value); } })),
                React.createElement(Field, { label: "Signal" },
                    React.createElement(Dropdown, { items: signalItems, currentSelection: signalId, onClick: setSignalId })),
                React.createElement(Field, { label: "Response" },
                    React.createElement(Dropdown, { items: responseItems, currentSelection: responseId, onClick: setResponseId })),
                React.createElement("div", { className: "grid grid-cols-2 gap-[8px]" },
                    React.createElement(Field, { label: "Threshold (0..1)" },
                        React.createElement(TextInput, { type: "number", step: "0.001", min: "0", max: "1", value: threshold, onChange: function (e) { return setThreshold(e.target.value); } })),
                    React.createElement(Field, { label: "Priority (int)" },
                        React.createElement(TextInput, { type: "number", step: "1", value: priority, onChange: function (e) { return setPriority(e.target.value); } }))),
                React.createElement(Field, { label: "Alert Severity" },
                    React.createElement(Dropdown, { items: SEVERITY_ITEMS, currentSelection: alertSeverity, onClick: function (v) { return setAlertSeverity(v); } })),
                React.createElement("label", { className: "flex flex-row items-center gap-x-[8px]" },
                    React.createElement("input", { type: "checkbox", checked: enabled, onChange: function (e) { return setEnabled(e.target.checked); } }),
                    React.createElement("span", { className: "text-black-400 font-N8" }, "Enabled")),
                error && React.createElement("div", { className: "text-red font-N8" }, error),
                React.createElement("div", { className: "flex flex-row justify-end gap-x-[8px]" },
                    React.createElement(StyledButton, { text: "Cancel", style: StyledButtonStyle.Gray, onClick: onClose }),
                    React.createElement(StyledButton, { text: saving ? "Saving..." : existing ? "Save" : "Create", onClick: save, disabled: saving }))))));
};
var Field = function (_a) {
    var label = _a.label, children = _a.children;
    return (React.createElement("label", { className: "flex flex-col gap-y-[4px]" },
        React.createElement("span", { className: "text-black-400 font-N8" }, label),
        children));
};
